module.exports = __webpack_public_path__ + "img/marriage.820a6bb5.png";